import React from 'react';
import { IconProps } from '.';

const SvgCircleInstagram = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='url(#CircleInstagram_svg__a)'
        d='M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Z'
      />
      <path
        fill='url(#CircleInstagram_svg__b)'
        d='M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Z'
      />
      <path fill='#fff' d='M16.333 8.389a.722.722 0 1 1-1.444 0 .722.722 0 0 1 1.444 0Z' />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M12 15.611a3.611 3.611 0 1 0 0-7.222 3.611 3.611 0 0 0 0 7.222Zm0-1.213a2.398 2.398 0 1 0 0-4.796 2.398 2.398 0 0 0 0 4.796Z'
        clipRule='evenodd'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M5.5 9.214A3.714 3.714 0 0 1 9.214 5.5h5.572A3.714 3.714 0 0 1 18.5 9.214v5.572a3.714 3.714 0 0 1-3.714 3.714H9.214A3.714 3.714 0 0 1 5.5 14.786V9.214Zm3.714-2.5h5.572a2.501 2.501 0 0 1 2.5 2.5v5.572a2.501 2.501 0 0 1-2.5 2.5H9.214a2.501 2.501 0 0 1-2.5-2.5V9.214a2.501 2.501 0 0 1 2.5-2.5Z'
        clipRule='evenodd'
      />
      <defs>
        <radialGradient
          id='CircleInstagram_svg__a'
          cx={0}
          cy={0}
          r={1}
          gradientTransform='matrix(-7.9198 -27.72002 41.23042 -11.77981 19.59 25.97)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.198} stopColor='#F50B5E' />
          <stop offset={0.52} stopColor='#DF0897' />
          <stop offset={0.769} stopColor='#962FBF' />
          <stop offset={0.933} stopColor='#4F5BD5' />
        </radialGradient>
        <radialGradient
          id='CircleInstagram_svg__b'
          cx={0}
          cy={0}
          r={1}
          gradientTransform='rotate(-54.972 26.29 3.456) scale(14.3734 15.7218)'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset={0.094} stopColor='#FEDA75' />
          <stop offset={0.475} stopColor='#FA7E1E' />
          <stop offset={1} stopColor='#FA7E1E' stopOpacity={0} />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default SvgCircleInstagram;
